import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DocFeedbackStatusDB } from '../../../../../api/types/docs/doc-feedback-status';
import { Nullable } from 'primereact/ts-helpers';

export interface DocsFiltersBarProps {
  filterDocTypeName: string | null;
  setFilterDocTypeName: (value: string | null) => void;
  docTypeNameOptions: { label: string; value: string }[];

  filterStatus: DocFeedbackStatusDB | null;
  setFilterStatus: (value: DocFeedbackStatusDB | null) => void;
  statusOptions: { label: string; value: DocFeedbackStatusDB }[];

  filterCreatedAtFrom: Nullable<Date>;
  setFilterCreatedAtFrom: (value: Nullable<Date>) => void;
  filterCreatedAtTo: Nullable<Date>;
  setFilterCreatedAtTo: (value: Nullable<Date>) => void;

  onClear: () => void;
}

export const DocsFiltersBar: React.FC<DocsFiltersBarProps> = ({
  filterDocTypeName,
  setFilterDocTypeName,
  docTypeNameOptions,
  filterStatus,
  setFilterStatus,
  statusOptions,
  filterCreatedAtFrom,
  setFilterCreatedAtFrom,
  filterCreatedAtTo,
  setFilterCreatedAtTo,
  onClear,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '12px',
        alignItems: 'end',
        flexWrap: 'wrap',
        marginTop: '12px',
        marginBottom: '12px',
      }}
    >
      <div style={{ minWidth: '220px' }}>
        <div style={{ fontSize: '14px', color: '#4b5563' }}>סוג מסמך</div>
        <Dropdown
          value={filterDocTypeName}
          options={docTypeNameOptions}
          onChange={(e) => setFilterDocTypeName(e.value)}
          placeholder="כל הסוגים"
          style={{ width: '100%' }}
        />
      </div>

      <div style={{ minWidth: '220px' }}>
        <div style={{ fontSize: '14px', color: '#4b5563' }}>סטטוס</div>
        <Dropdown
          value={filterStatus}
          options={statusOptions}
          onChange={(e) => setFilterStatus(e.value)}
          placeholder="כל הסטטוסים"
          style={{ width: '100%' }}
        />
      </div>

      <div style={{ minWidth: '220px' }}>
        <div style={{ fontSize: '14px', color: '#4b5563' }}>מתאריך יצירה</div>
        <Calendar
          value={filterCreatedAtFrom}
          onChange={(e) => setFilterCreatedAtFrom(e.value)}
          dateFormat="dd/mm/yy"
          showIcon
          style={{ width: '100%', direction: 'ltr' }}
          inputStyle={{ width: '100%', textAlign: 'right' }}
        />
      </div>

      <div style={{ minWidth: '220px' }}>
        <div style={{ fontSize: '14px', color: '#4b5563' }}>עד תאריך יצירה</div>
        <Calendar
          value={filterCreatedAtTo}
          onChange={(e) => setFilterCreatedAtTo(e.value)}
          dateFormat="dd/mm/yy"
          showIcon
          style={{ width: '100%', direction: 'ltr' }}
          inputStyle={{ width: '100%', textAlign: 'right' }}
          minDate={filterCreatedAtFrom ?? undefined}
        />
      </div>

      <Button
        label="נקה מסננים"
        severity="secondary"
        outlined
        onClick={onClear}
      />
    </div>
  );
};
